import { inject, Injectable } from '@angular/core';

import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { UserStateService } from 'src/app/auth/services/user-state.service';

import { ExternalLoggingService } from './external-logging.service';

@Injectable({
  providedIn: 'root',
})
export class BigQueryLoggingService {
  private readonly externalLoggingService = inject(ExternalLoggingService);
  private readonly userStateService = inject(UserStateService);
  private readonly companyStateService = inject(CompanyStateService);

  logEvent(
    eventName: string,
    eventDetails?: unknown,
    eventValue?: unknown,
    username?: string | null,
    companyId?: string | null,
  ) {
    return this.externalLoggingService.logEvent(
      eventName,
      eventDetails,
      eventValue,
      username || this.userStateService.getUsername(),
      companyId || this.companyStateService.getSelectedCompanyId(),
    );
  }
}
